import React, { useState } from 'react';
import { Card, Button, Tag, Row, Col, Popover, Checkbox, Popconfirm } from 'antd';
import { CloseOutlined, DeleteOutlined, EditOutlined, FilterFilled, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import BreadcrumbComponent from '../../../components/Breadcrumb';
import { IBreadcrumbItem } from '../../../models/breadcrumb';
import { useTranslation } from 'react-i18next';
import './styles.css';
import { IDropdown } from '../../../models/input';
import { useNavigate } from 'react-router-dom';
import editIndicator from '../../../assets/images/edit.svg';
import deleteIndicator from '../../../assets/images/delete.svg';

interface ReportsMappingProps {
    ministries: any[];
    handleAddEditReportsMapping?: (value?: any) => void;
    associatedReports: IDropdown[];
    filterSelectedReports: number[];
    filterOnChange: (checkedValued: number[]) => void;
    isAllSelected: boolean;
    handleDeleteReport?: (value?: any) => void;
}

const ReportsMapping: React.FC<ReportsMappingProps> = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [expandedMinistries, setExpandedMinistries] = useState<number[]>([]);

    const breadcrumbItems: Array<IBreadcrumbItem> = [
        { title: t('home'), path: '/home' },
        { title: t('menu.setup.reports-mapping') },
    ];

    const toggleExpandedMinistries = (ministryId: number) => {
        if (expandedMinistries.includes(ministryId)) {
            setExpandedMinistries(expandedMinistries.filter(item => item !== ministryId));
        }
        else {
            setExpandedMinistries([...expandedMinistries, ministryId]);
        }
    };

    return (
        <Row className='mainTextArea' style={{ width: '100%' }} justify="space-between"  >
            <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                <Row gutter={[16, 16]} style={{ borderBottom: '1px solid #CCC', marginBottom: '10px', paddingBottom: '10px' }}>
                    <Col xs={24} sm={24} md={17} lg={17} xl={17} >
                        <h4>{t('menu.setup.reports-mapping')}</h4>
                        <BreadcrumbComponent items={breadcrumbItems} separator='>' />
                    </Col>
                    <Col xs={24} sm={24} md={7} lg={7} xl={7} className='actionButHolder' style={{ padding: '8px 0 0' }}>
                        <div style={{ paddingBottom: '10px 0' }}>
                            <Popover
                                placement='bottom'
                                trigger={'click'}
                                content={
                                    <>
                                        <div className='filterSelected'>
                                            <Checkbox
                                                checked={props.isAllSelected}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    props.filterOnChange(checked ? props.associatedReports.map(report => report.id) : []);
                                                }}>
                                                {t('select-all')}
                                            </Checkbox>
                                            <Checkbox.Group
                                                style={{ display: 'block' }}
                                                value={props.filterSelectedReports}
                                                onChange={(checkedValues) => { props.filterOnChange(checkedValues) }}>
                                                {props.associatedReports.map((report) => (
                                                    <Checkbox key={report.id} value={report.id}>
                                                        {report.name}
                                                    </Checkbox>
                                                ))}
                                            </Checkbox.Group>
                                        </div>
                                        <div className='filterclearAll'>
                                            <Button type='link' onClick={() => { props.filterOnChange([]) }}>
                                                <CloseOutlined />  <span style={{ padding: '0 10px' }}>{t('clear-all')}</span>
                                            </Button>
                                        </div>
                                    </>
                                }>
                                <Button disabled={props?.associatedReports?.length ? false : true} type="primary"><FilterFilled /> {t('btn.filter')}</Button>
                            </Popover>
                            <Button onClick={() => navigate('/setup/reports-mapping/add')} type="primary">{t('btn.map.reports')}</Button>
                        </div>
                    </Col>
                </Row>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='cardScrollBar'>
                {props?.ministries && props?.ministries?.length &&
                    props.ministries.map((ministry: any) => {
                        const isExpanded = expandedMinistries.includes(ministry.id);
                        const displayReports = isExpanded ? ministry.reports : ministry.reports.slice(0, 4);

                        return (
                            <Card
                                className='ministriesCard'
                                key={ministry.id}
                                title={ministry.name}
                                extra={
                                    <>
                                        {
                                            ministry?.reports?.length ? 

                                                <img src={editIndicator} onClick={() => navigate(`/setup/reports-mapping/edit/${ministry.id}`)}  style={{ margin: 10, cursor:'pointer' }}/> 
                                                : <PlusOutlined onClick={() => navigate(`/setup/reports-mapping/edit/${ministry.id}`)} />
                                        }
                                        <Popconfirm
                                            title={t('confirmation')}
                                            description={t('mapping.delete.msg')}
                                            okText={t('yes')}
                                            cancelText={t('no')}
                                            onConfirm={() => props?.handleDeleteReport?.(ministry.id)}
                                        >
                                            <img src={deleteIndicator} style={{ margin: 10, cursor:'pointer' }}/>  
                                        </Popconfirm>
                                    </>
                                }
                                style={{ margin: '10px 10px' }}>

                                <Row gutter={[16, 16]}>
                                    {displayReports?.map((report: any) => (
                                        <Col key={report.id}>
                                            <Tag className={props.filterSelectedReports.includes(report.id) ? 'tag_highlite ' : ''}>{report.name}</Tag>
                                        </Col>
                                    ))}
                                </Row>
                                {ministry?.reports?.length > 4 &&
                                    <Button onClick={() => toggleExpandedMinistries(ministry.id)} type="link" className='showmore'>
                                         {isExpanded ? (<><MinusOutlined /> {t('btn.show-less')}</>) : (<><PlusOutlined /> {t('btn.show-more')}</>)}
                                    </Button>
                                }
                            </Card>);
                    })}
            </Col>
        </Row>
    );
};

export default ReportsMapping;